import type { SxProps, Theme } from '@mui/material';

export const container: SxProps<Theme> = {
  px: 2,
  flexGrow: 1,
  pb: 10,
};

export const sectionContainer: SxProps<Theme> = {
  mb: 4,
};

export const sectionContainerWithPosition: SxProps<Theme> = {
  mb: 4,
  position: 'relative',
};
